import { render, staticRenderFns } from "./StockValuation.vue?vue&type=template&id=451865be&"
import script from "./StockValuation.vue?vue&type=script&lang=js&"
export * from "./StockValuation.vue?vue&type=script&lang=js&"
import style0 from "./StockValuation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports